// src/features/imports/selectors/imports.selectors.ts

import type {
  ImportsFeatureState,
  DriverImportId,
  VehicleImportId,
} from "../model/imports.state.types";

import { sortDriverImportIds, sortVehicleImportIds } from "./imports.sort";

// ---------- utils ----------

function includesCI(haystack: string, needle?: string): boolean {
  if (!needle) return true;
  const n = needle.trim().toLowerCase();
  if (!n) return true;
  return haystack.toLowerCase().includes(n);
}

// ---------- base ID selectors ----------

export function selectAllDriverImportIds(state: ImportsFeatureState): DriverImportId[] {
  return Object.keys(state.readModel.driverItemsById);
}

export function selectAllVehicleImportIds(state: ImportsFeatureState): VehicleImportId[] {
  return Object.keys(state.readModel.vehicleItemsById);
}

// ---------- filtered + sorted ----------

export function selectVisibleDriverImportIds(
  state: ImportsFeatureState
): DriverImportId[] {
  const { readModel, ui, view } = state;
  const f = view.driverFilter;

  const filtered = selectAllDriverImportIds(state).filter((id) => {
    if (ui.removedDriverImportIds.has(id)) return false;

    const item = readModel.driverItemsById[id];
    if (!item) return false;

    // bucket filter
    if (f.bucket && f.bucket !== "all" && item.bucket !== f.bucket) return false;

    // file filter
    if (f.fileId && f.fileId !== "all" && item.fileId !== f.fileId) return false;

    // selected only
    if (f.onlySelected && !ui.selectedDriverImportIds.has(id)) return false;

    // search
    const hay = `${item.fullName} ${item.cardNumber}`;
    if (!includesCI(hay, f.search)) return false;

    return true;
  });

  return sortDriverImportIds(state, filtered);
}

export function selectVisibleVehicleImportIds(
  state: ImportsFeatureState
): VehicleImportId[] {
  const { readModel, ui, view } = state;
  const f = view.vehicleFilter;

  const filtered = selectAllVehicleImportIds(state).filter((id) => {
    if (ui.removedVehicleImportIds.has(id)) return false;

    const item = readModel.vehicleItemsById[id];
    if (!item) return false;

    if (f.bucket && f.bucket !== "all" && item.bucket !== f.bucket) return false;
    if (f.fileId && f.fileId !== "all" && item.fileId !== f.fileId) return false;
    if (f.onlySelected && !ui.selectedVehicleImportIds.has(id)) return false;

    const hay = item.registrationNumber;
    if (!includesCI(hay, f.search)) return false;

    return true;
  });

  return sortVehicleImportIds(state, filtered);
}
